export default "__VITE_ASSET__Chnp8fsN__"